import React from 'react';
import { Redirect, Route, RouteProps, withRouter } from 'react-router';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { IStore } from 'reducers/index';
import { connect } from 'react-redux';
import { hasRequiredRole, IRoles } from 'utilities/roles';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { IFeatureToggleModel } from '../../reducers/featureToggle/models';
import { isFeatureEnabled } from '../../utilities/featureToggles';
import { LoadingAnimation } from 'components/loading';

interface IRouteWithPermissionsOwnProps extends RouteProps, IMapStateToProps {
    functions: BUSINNESS_FUNCTIONS[];
    featuresToRestrict?: FEATURE_TOGGLES[];
}

class _RouteWithPermissions extends React.Component<IRouteWithPermissionsOwnProps> {
    public render() {        
        if (this.hasRequiredPermission(this.props.roles) && this.isFeatureToggleEnabled(this.props.featureToggles)) {
            return <Route {...this.props} />;
        }     
        if(this.props.featuresToRestrict!==undefined && !this.props.featureDataLoaded){
            return <LoadingAnimation/>
        }
        return <Redirect to="/unauthorized" />;
    }

    private hasRequiredPermission = (roles: IRoles[]) => hasRequiredRole(this.props.functions, roles);
    private isFeatureToggleEnabled = (features: IFeatureToggleModel[]) => isFeatureEnabled(features, this.props.featuresToRestrict);
}

interface IMapStateToProps {
    roles: IRoles[];
    featureToggles: IFeatureToggleModel[];
    featureDataLoaded:boolean
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    roles: state.user.roles,
    featureToggles: state.featureToggle.featureToggles,
    featureDataLoaded: state.featureToggle.isFeatureDataReady
});

export const RouteWithPermissions = withRouter(connect(mapStateToProps)(_RouteWithPermissions) as any) as any;